exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-input[data-v-ce8be222] {\n\n  border-radius: 5px; /* Đặt góc bo viền */\n  padding: 3px;\n  margin: 5px;\n}\n", ""]);

// exports
